import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Stepper,
  Step,
  StepLabel,
  StepButton,
  StepConnector,
  Typography,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Hidden,
} from '@material-ui/core'
import { ExpandMore, NavigateNext, NavigateBefore } from '@material-ui/icons'
import Button from 'components/theme/Button'
import { withRouter } from 'react-router-dom'
import { readOnboarding, toggleExpansionPanel } from 'actions/onboarding'
import styles from './styles'
import steps from './steps'
import stepService from './stepService'
import stepContent from './stepContent'
import routes from './routes'
import SvgIcon from './SvgIcon'
import MobileStepper from './MobileStepper'
import routeObj from './routeObj'
import errorLocation from './errorLocation'
import language from 'utils/vast-languagepack'

export default withRouter(
  connect(
    state => ({
      loadStatus: state.loadStatus.onboarding,
      onboarding: state.onboarding,
    }),
    dispatch => bindActionCreators({ readOnboarding, toggleExpansionPanel }, dispatch)
  )(
    withStyles(styles)(
      class Onboarding extends Component {
        componentDidMount() {
          if (!this.props.loadStatus) {
            this.props.readOnboarding().then(result => {
              if (result.incomplete_steps && result.incomplete_steps.length && this.props.history && this.props.history.location && (this.props.history.location.pathname === '/' || this.props.history.location.pathname === '')) {
                this.props.history.push(
                  routes([]).find(
                    (route, idx) =>
                      (stepService[idx] || 'Unknown').indexOf(
                        result.incomplete_steps[0].description
                      ) > -1
                  )
                )
              }
            })
          }
        }

        handleNext = () => {
          let activeStep
          const currentActiveStep = this.activeStep()

          if (currentActiveStep || currentActiveStep === 0) {
            if (
              currentActiveStep === steps.length - 1 &&
              !this.allStepsCompleted()
            ) {
              // It's the last step, but not all steps have been completed,
              // find the first step that has been completed
              activeStep = steps.findIndex(
                (step, i) => !(i in this.props.onboarding.completed)
              )
            } else {
              activeStep = currentActiveStep + 1
            }
  
            this.handleStep(activeStep)
          } else {
            this.handleStep(0)
          }
        }

        handleBack = () => {
          const activeStep = this.activeStep()
          if (activeStep || activeStep === 0) {
            this.handleStep(activeStep < 0 ? 0 : activeStep - 1)
          } else {
            this.handleStep(0)
          }
        }

        handleStep = step => {
          this.props.history.push(routes(this.props.onboarding.completed)[step])
        }

        activeStep = () => {
          const stepit = this.props.location.pathname.split("/")[1] ? this.props.location.pathname.split("/")[1] : 'accountsettings';
                   return routeObj['/' + stepit]
          }

        allStepsCompleted = () =>
          Object.keys(this.props.onboarding.completed).length === steps.length

        reset = () =>
          this.props.history.push(routes(this.props.onboarding.completed)[0])

        render() {
          const { classes, onboarding, toggleExpansionPanel } = this.props
          const activeStep = this.activeStep()

          const content = this.allStepsCompleted() ? (
            <div>
              <Typography className={classes.instructions}>
                {language.onboarding.stepsCompleted}&apos;{language.onboarding.stepsCompleted2}
              </Typography>
              <Button onClick={this.reset}>{language.onboarding.rest}</Button>
            </div>
          ) : (
            <div>
              <div className={classes.instructions}>
                <span className={classes.instructionLabel}>{activeStep || activeStep === 0 ? `${
                  steps[activeStep]
                }: ` : null}</span>
                {stepContent[activeStep] || 'Unknown step'}
              </div>
              <div>
                {activeStep !== steps.length &&
                  (onboarding.completed[activeStep] ? (
                    <Typography
                      variant="caption"
                      className={classes.stepsCompleted}
                    >
                      {language.onboarding.step} {activeStep + 1} {language.onboarding.alreadyCompleted}
                    </Typography>
                  ) : null)}
              </div>
            </div>
          )

          return onboarding && onboarding.setup_complete === false ? (
            <div className={classes.container}>
              <ExpansionPanel
                className={classes.expansionPanel}
                defaultExpanded
                onChange={(event, expanded) => toggleExpansionPanel(expanded)}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1c-content"
                  id="panel1c-header"
                  classes={{ content: classes.summaryContent }}
                >
                  <div style={{ maxWidth: '100%' }}>
                    <Typography noWrap={!onboarding.expanded} className={classes.heading}>
                      {language.onboarding.welcomeToVast}{' '}
                      <em>
                        <strong>{language.onboarding.completeSteps}</strong>{language.onboarding.completeSteps2}
                      </em>
                    </Typography>
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                  classes={{ root: classes.expansionPanelDetailsRoot }}
                >
                  <Hidden mdUp>
                    <div>
                      <div
                        style={{
                          marginRight: 12,
                          display: 'inline-block',
                          verticalAlign: 'top',
                          marginTop: 8,
                        }}
                      >
                        <SvgIcon
                          active
                          completed={onboarding.completed[activeStep]}
                          textContent={activeStep || activeStep === 0 ? activeStep + 1 : '?'}
                          errorLocation={errorLocation[activeStep]}
                        />
                      </div>
                      <div
                        style={{
                          width: 'calc(100% - 60px)',
                          display: 'inline-block',
                        }}
                      >
                        {content}
                      </div>
                    </div>
                    <div>
                      <MobileStepper
                        completed={onboarding.completed}
                        activeStep={activeStep}
                        handleNext={this.handleNext}
                        handleBack={this.handleBack}
                        numberOfSteps={steps.length}
                      />
                    </div>
                  </Hidden>
                  <Hidden smDown>
                    <div className={classes.wizard}>
                      <Button
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        color="secondary"
                        className={classes.buttonBack}
                      >
                        <NavigateBefore />
                        {language.onboarding.back}
                      </Button>{' '}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={this.handleNext}
                        className={classes.buttonNext}
                      >
                        {language.onboarding.next}
                        <NavigateNext />
                      </Button>
                      <Stepper
                        connector={
                          <StepConnector
                            classes={{
                              alternativeLabel: classes.alternativeLabel,
                            }}
                          />
                        }
                        alternativeLabel
                        nonLinear
                        activeStep={activeStep || 0}
                      >
                        {steps.map((label, index) => (
                          <Step key={label}>
                            <StepButton
                              onClick={() => this.handleStep(index)}
                              completed={onboarding.completed[index]}
                            >
                              <StepLabel
                                classes={{
                                  iconContainer: classes.iconContainer,
                                  completed: classes.stepLabelCompleted,
                                  active: classes.stepLabelActive,
                                }}
                                StepIconProps={{
                                  icon: (
                                    <SvgIcon
                                      active={activeStep === index}
                                      completed={onboarding.completed[index]}
                                      textContent={index + 1}
                                      errorLocation={errorLocation[index]}
                                    />
                                  ),
                                }}
                              >
                                {label}
                              </StepLabel>
                            </StepButton>
                          </Step>
                        ))}
                      </Stepper>
                      <div>{content}</div>
                    </div>
                  </Hidden>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          ) : null
        }
      }
    )
  )
)
//TODO: on delete action (forms, groups, tasks, contacts) dispatch onboarding read action if count is 1.
//on create action dispatch onboarding read action if setup_complete===false
